'use strict';

//import "core-js/stable";

//npm install --save core-js@3




//Apparently, IE9 and above supports Array.forEach but not for NodeList, which querySelector returns. I tried Array.from() to no avail as it requires ES6 or use ES6-shim.
// IE Polyfill forEach for NodeList
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
    // Yes, there's really no need for `Object.defineProperty` here
    NodeList.prototype.forEach = Array.prototype.forEach;
}

Number.prototype.format = function(n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};


(function() {
window.requestAnimationFrame = window.requestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function(f){return setTimeout(f, 1000/60)} // simulate calling code 60 
 
window.cancelAnimationFrame = window.cancelAnimationFrame
    || window.mozCancelAnimationFrame
    || function(requestID){clearTimeout(requestID)} //fall back
})();


import { _siteController } from "./App/SiteController.js";


window.addEventListener('DOMContentLoaded',() => {  


	let eshopItemsIncrementator = document.querySelectorAll('.item-in-cart-count-increment');

	if (eshopItemsIncrementator) {
		eshopItemsIncrementator.forEach((item) => {
			let counter = item.querySelector('.count-value');
			let up = item.querySelector('.increment');
			let down = item.querySelector('.decrement');
			
			down.addEventListener('click', (e) => {
				e.preventDefault();
				let val = parseInt(counter.value);
				if (val > 1) {
					counter.value = val - 1;
				}
			});
			
			up.addEventListener('click', (e) => {
				e.preventDefault();
				let val = parseInt(counter.value);
					counter.value = val + 1;
			});
			
		});
	}




	// Carousel on Obvject Page
	
	let car_container = document.querySelector('#carousel-vendors');
	if (car_container) {
		let glide = new Glide(car_container, {
		  type: 'carousel',
		  perView: 5,
		  focusAt: 'center',
		  breakpoints: {
			800: {
			  perView: 3
			},
			480: {
			  perView: 2
			}
		  }
		})

		glide.mount();
	}


	// Carousel on Obvject Page
	
	let crt_container = document.querySelector('#carousel-certificate');
	if (crt_container) {

		let glide = new Glide(crt_container, {
		  type: 'slider',
		  perView: 5,
		  focusAt: 0,
		  breakpoints: {
			800: {
			  perView: 3
			},
			480: {
			  perView: 2
			}
		  }
		})

		glide.mount();
	}
	
	let same_container = document.querySelector('#carousel-pohojie_tovari');
	if (same_container) {

		let glide = new Glide(same_container, {
		  type: 'slider',
		  perView: 4,
		  focusAt: 0,
		  breakpoints: {
			800: {
			  perView: 2
			},
			480: {
			  perView: 1
			}
		  }
		})

		glide.mount();
	}
});


window.addEventListener('DOMContentLoaded',() => {    
    ['touchstart','touchmove','touchend','touchcancel','gesturestart','gesturechange','gestureend','orientationchange'].forEach(function(ev) {
        document.body.addEventListener(ev,function(e) {
			
        });
    });
});



